module.exports = __webpack_public_path__ + "fonts/materialicons.8fd34a1d.woff2";